import React from "react";
import PropTypes from "prop-types";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Text,
} from "@chakra-ui/core";
import styled from "@emotion/styled";
import { useRouter } from "next/router";

const Breadcrumbs = ({ breadcrumbs, ...rest }) => {
  const router = useRouter();
  // Breaks down the URL from "/foo/bar" to
  // ["/", "/foo", "/foo/bar"] for our breadcrumb links
  const partialPaths = router.pathname
    .split("/")
    .slice(1)
    .reduce(
      (acc, crumb) => {
        return [...acc, `${acc[acc.length - 1]}${crumb}/`];
      },
      ["/"]
    )
    .map((s) => {
      if (s === "/") return s;
      return s.substring(0, s.length - 1);
    });

  return (
    <StyledBreadcrumb display={["none", "none", "block"]} mb="60px" {...rest}>
      {breadcrumbs.map((breadcrumb, i) => (
        <BreadcrumbItem key={breadcrumb}>
          {partialPaths[i] ? (
            <BreadcrumbLink href={partialPaths[i]}>{breadcrumb}</BreadcrumbLink>
          ) : (
            <Text>{breadcrumb}</Text>
          )}
        </BreadcrumbItem>
      ))}
    </StyledBreadcrumb>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.string),
};

const StyledBreadcrumb = styled(Breadcrumb)`
  ol {
    margin: 0 !important;
  }
`;

export default Breadcrumbs;
